export default __webpack_public_path__ + "static/media/mike-connelly.ff8e09cb.png";